import { Configuration } from "../api";
import { SitesApi } from "../api/api";
import { useQuery } from "react-query";

const useSites = (basePath: string, customerId: string) => {
  const sitesApi = new SitesApi(new Configuration({ basePath }));
  return useQuery("sites", async () => {
    const res = await sitesApi.allSites(customerId);
    res.data.push({
      id: "0",
      name: "なし",
    });

    return res.data;
  });
};

export default useSites;
